/**
 * 对 sweetalert2 封装
 * 可以直接使用 this.$swal，和之前用法类似
 * 2021-06-03
 */
import Swal from "sweetalert2";
const options = {
  heightAuto: false,
  customClass: "mySweetalert2",
};
let swalMixin = Swal.mixin(options);

const $swal = (options) => {
  options = options || {};
  if (typeof options === "string") {
    options = {
      text: options,
    };
  }

  return swalMixin.fire(options);
};
$swal.Swal = Swal;
$swal.setOpt = (obj) => {
  swalMixin = Swal.mixin({ ...options, ...obj });
};
//alert提示
["success", "error", "info", "warning"].map((icon) => {
  $swal[icon] = (message, confirmFun) => {
    if (typeof message === "string") {
      message = {
        text: message,
      };
    }
    message.icon = icon;
    $swal(message).then(() => {
      confirmFun && confirmFun();
    });
  };
});
$swal.alert = $swal.warning;
//confirm提示
$swal.confirm = (message, confirmFun, cancelFun) => {
  if (typeof message === "string") {
    message = {
      text: message,
    };
  }
  message.icon = "warning";
  message.showCancelButton = true;

  $swal(message).then((result) => {
    if (result.value) return confirmFun && confirmFun();
    console.log(result);
    if (result.dismiss === "cancel") return cancelFun && cancelFun();
  });
};
//toast提示，3秒后消失
["fadeSuccess", "fadeError", "fadeInfo", "fadeWarning"].map((icon) => {
  $swal[icon] = (message, closeFun) => {
    if (typeof message === "string") {
      message = {
        title: message,
        didOpen: (toast) => {
          toast.onclick = Swal.close;
        },
      };
    }
    message.icon = icon.replace("fade", "").toLowerCase();
    message.timer = 3000;
    message.toast = true;
    message.showConfirmButton = false;

    $swal(message).then(() => {
      closeFun && closeFun();
    });
  };
});
$swal.fadeAlert = $swal.fadeWarning;
//延迟关闭，5秒钟后允许关闭
$swal.delayClose = ({ text, btnTxt }, callback) => {
  let timeoutFun;
  $swal({
    icon: "warning",
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    html: `${text}<br><button id="swal_delay_close_button" class="swal2-confirm swal2-styled" disabled></button>`,
    didOpen: () => {
      const content = Swal.getHtmlContainer();
      const $ = content.querySelector.bind(content);
      const btn = $("#swal_delay_close_button");

      let sec = 5;
      countDown();

      btn.onclick = () => {
        if (sec) return;
        Swal.close();
        callback && callback();
      };

      function countDown() {
        const str = btnTxt + (sec ? ` (${sec}S)` : "");
        if (btn.innerText !== undefined) {
          btn.innerText = str;
        } else if (btn.textContent !== undefined) {
          btn.textContent = str;
        }
        if (!sec) return btn.removeAttribute("disabled");

        sec--;
        timeoutFun = setTimeout(countDown, 1000);
      }
    },
    willClose: () => {
      clearTimeout(timeoutFun);
    },
  });
};

export default $swal;
